<template>
    <div>
        <!-- Page header -->
        <div class="sm:flex sm:justify-between sm:items-center mb-5">
            <!-- Left: Title -->
            <div class="mb-4 sm:mb-0">
                <h1 class="text-2xl md:text-3xl text-gray-800 font-bold">My Accounts</h1>
            </div>

            <!-- Right: Actions -->
            <div
                class="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2"
            ></div>
        </div>
        <!-- END PAGE HEADER -->

        <!-- TABLE -->
        <div class="bg-white shadow-lg rounded-sm border border-gray-200 mb-8">
            <header class="px-5 py-4">
                <h2 class="font-semibold text-gray-800">
                    All Accounts
                    <span class="text-gray-400 font-medium">{{ accounts.length }}</span>
                </h2>
            </header>
            <!-- Table -->
            <div class="overflow-x-auto">
                <table class="w-full">
                    <!-- Table header -->
                    <thead
                        class="
                            text-xs
                            font-semibold
                            uppercase
                            text-gray-500
                            bg-gray-50
                            border-t border-b border-gray-200
                        "
                    >
                        <tr>
                            <th class="p-4 text-left" width="70">Logo</th>
                            <th class="p-4 text-left" width="130">Name</th>
                            <th class="p-4 text-left" width="130">Connected Card</th>
                            <th class="p-4 text-left" width="80">Reason</th>
                            <th class="p-4 text-center" width="80">Enabled</th>
                        </tr>
                    </thead>
                    <!-- Table body -->
                    <tbody class="text-sm divide-y divide-gray-200">
                        <!-- Row -->
                        <tr v-for="account in accounts" :key="account.id">
                            <td class="p-4">
                                <img
                                    :src="account.institution.medium_logo_url"
                                    :alt="account.name"
                                    width="50"
                                    height="50"
                                />
                            </td>
                            <td class="p-4">{{ account.name }}</td>
                            <td class="p-4">
                                <select
                                    class="w-full"
                                    v-model="account.card_id"
                                    @change="updateConnectedCard(account)"
                                >
                                    <option value=""></option>
                                    <option v-for="card in cards" :value="card.id" :key="card.id">
                                        {{ card.title }}
                                    </option>
                                </select>
                            </td>
                            <td class="p-4">
                                {{ account.reason === 'notlisted' ? 'Pending: Not listed' : '' }}
                            </td>
                            <td class="p-4 text-center">
                                <input
                                    type="checkbox"
                                    :checked="account.visible"
                                    v-model="account.visible"
                                    @change="updateConnectedCard(account)"
                                />
                            </td>
                        </tr>
                        <!-- Row -->
                    </tbody>
                </table>
            </div>
        </div>
        <!-- END TABLE -->
    </div>
</template>

<script>
export default {
    props: [],
    components: {},
    filters: {},
    computed: {},
    data: () => ({
        errors: [],
        wallet: {},
        users: [],
        cards: [],
        accounts: [],
        itemsCount: 0,
    }),
    methods: {
        getAccounts() {
            ApiService.apiCall('/wallets', 'get')
                .then((response) => {
                    this.wallet.id = response.data.wallet.id;
                    ApiService.apiCall('/wallets/' + this.wallet.id + '/accounts', 'get')
                        .then((response) => {
                            this.accounts = response.data.accounts;
                            this.cards = response.data.cards;
                        })
                        .catch((response) => {
                            this.$root.handleHttpStatus(response);
                        });
                })
                .catch((response) => {
                    this.$root.handleHttpStatus(response);
                });
        },
        updateConnectedCard(account) {
            ApiService.apiCall(
                '/wallets/' + this.wallet.id + '/accounts/' + account.id,
                'put',
                account
            )
                .then((response) => {})
                .catch((response) => {
                    this.$root.handleHttpStatus(response);
                });
        },
        closeModal(modal) {
            this[modal] = false;
        },
    },
    created() {},
    mounted() {
        this.getAccounts();
    },
};
</script>
